// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentAttempts_container__3WDg8","headerTitle":"PaymentAttempts_headerTitle__1K1zx"};